
import Vue from "vue";
export default Vue.extend({
  name: "ManagerShare",
  components: {
  },
  data() {
    return {
      label: "课件",
      pageSize: 8,
      pageIndex: 1,
      totalCount: 0,
      name: "source",
      list: [],
      nodePathList: [],
      courseName: "22",
      dataCount: 1,
      folderId: "",
      sourceIds: [],
      checkedList: [],
      disabled: false,
      checkStatus: false,
      activeName: "school",
      xzdis:false,
      tab:true,
      impCourseId:""
    };
  },
  props: {
    courseId: {
      type: String,
      default: ""
    },
    activityIds: {
      
    },
    IsState:{
      type:Number,
      default:0
    },
    setData:{
      type:Array,
      default:()=>[]
    },
    CreatedSchoolId:{
      type:String,
      default:""
    },
    lable:{
      type:String,
      default:""
    },
    CouIsChoice:{
      type:String,
      default:""
    },
    // 资源类型 0 课件 ,1 题目 , 2 作业 , 3 目录  ,4 互动
    type:{
      type:Number,
      default:0
    },
    activityType:{
      type:String,
      default:""
    },
    childGet:{
      type:Object,
      default:() => {
        return {};
      }
    }
  },
  created() {
    this.getSourceList("source", 1);
  },
  watch: {
    setData(val){
      this.$emit('update:ids',val);
      // this.$emit("update:courseId", this.courseId);
      if(this.setData.length>0){
        this.xzdis=true;
      }else{
        this.xzdis=false;
      }
    },
    impCourseId(val){
      this.$emit('update:impCourseId',val);
    },
    IsState(){
       this.$emit('update:IsState',this.IsState)
    },
    checkData(val) {
      let checkLength = this.list.length;
      for (let i = 0; i < checkLength; i++) {
        if (this.list[i].checked) {
          if (this.list[i].checked == true) {
            this.list[i].chec1ked = false;
          }
        }
      }
    },
  },
  methods: {
    close(){
      this.$emit('update:IsState', Math.random());
    },
    getSourceList(type, page) {
      this.$nextTick(() => {
        GetSourceList(this.courseId, this.folderId, type, page).then(rst => {
          if(rst.code > 0){
              this.list = rst.list;
              this.totalCount = rst.pagination.totalCount;
              this.pageSize = rst.pagination.pageSize;
              this.courseName = rst.courseName;
              this.nodePathList = rst.nodePathList;
              this.dataCount = rst.dataCount;
              rst.list.forEach(item => {
                this.$set(this.checkedList, item.Id, false);
              });
          }else {
            return;
          }
        });
      });
    },
    // getResources(n){
    //   console.log(n);
    // }
    // ManagerGetmsg(val){
    //   this.$emit('judgeBtn',val)
    // },
    mangerBtnMsg(val){
      this.$emit('dialogBtn',val);
    },
    mangerPatnerBtnMsg(val){
      this.$emit('dialogrPatnerBtn',val);
    },
    handleClick(tab,event){
      this.$emit('tabClick',tab.index);
    },
    closeDialog(){
      this.$emit('closeDialog');
    }
  }
});
